import { Component } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { UserService } from '../service/user.service';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator, ConfirmDialog],
    providers: [ConfirmationService],
    template: ` <div class="layout-topbar">
        <p-confirmdialog key="logoutDialog" />
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <!-- <a class="layout-topbar-logo" routerLink="/">
                <img src="images/mediko-logo.png" alt="logo" width="60" height="60" class="mr-2" />
            </a> -->
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <div class="relative">
                                    <!-- Bagian rubah warna (palette/configurator) dikomentari
                        <button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"s
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button>-->
                    <app-configurator />
                </div>
            </div>

            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <button type="button" class="layout-topbar-action !w-auto !px-3 gap-2 text-blue-600 font-medium" (click)="switchToFreeclass()" title="Pindah ke Platform Freeclass OSCE">
                        <i class="pi pi-external-link"></i>
                        <span class="hidden md:inline">Freeclass OSCE</span>
                    </button>
                    <button type="button" class="layout-topbar-action" (click)="navigateToProfile()">
                        <i class="pi pi-user"></i>
                        <span>Profile</span>
                    </button>
                    <button type="button" class="layout-topbar-action" (click)="logout()">
                        <i class="pi pi-sign-out"></i>
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </div>
    </div>`
})
export class AppTopbar {
    items!: MenuItem[];

    constructor(
        public layoutService: LayoutService, private router: Router, private userService: UserService,private confirmationService: ConfirmationService
    ) {}

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    navigateToProfile() {
        this.router.navigate(['/app/profile']);
    }

    switchToFreeclass() {
        const token = localStorage.getItem('token');
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const freeclassBaseUrl = isLocal ? 'https://freeclass-osce.test' : 'https://oscemediko.id';

        if (token) {
            window.location.href = `${freeclassBaseUrl}/sso/from-timer?token=${encodeURIComponent(token)}`;
        } else {
            window.location.href = `${freeclassBaseUrl}/register`;
        }
    }

    logout(source: string = 'topbar') {
        this.confirmationService.confirm({
            message: 'Are you sure you want to logout?',
            header: 'Logout',
            icon: 'pi pi-exclamation-triangle',
            rejectButtonStyleClass: 'p-button-text',
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Logout',
                severity: 'danger',
            },
            accept: () => {
                if (source !== 'topbar') return;

                const token = localStorage.getItem('token');
                if (token) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('isLoggedIn');
                    localStorage.removeItem('user');
                    window.location.href = 'https://oscemediko.id/';
                }
            },
            reject: () => {

            },
            key: 'logoutDialog',
        });
    }
}
